export const globals = {
    TIPS: {
        NAME: "Tips4y",
        EMAIL: "suporte@tips4y.pt",
        SITE: "https://tips4y.datadrive.pt/",
        PHONE: "216057190",
        ADDRESS:
            "Rua Poeta Bocage Nr.2 - 3B | 1600-581 Lisboa | Portugal | Email: tips4y@tips4y.pt",
        INFOS: "TIPS 4Y - Sistemas de Informação Lda.",
    },
    ROLES: {
        ADMIN: 1,
        ACCOUNT_MANAGER: 2,
        USER: 5,
    },
    VRM_ACCESS_TIPOLOGY: {
        DATADRIVE: 1,
        API: 2,
        WEBSHOP: 3,
        CATALOG: 4,
        API_TECDOC: 5,
        VIN_SEARCH: 6,
        REFERENCE_SEARCH: 7,
    },
    MODULES: {
        VEHICLE_IDENTIFICATION: {
            ID: 1,
            ROUTE: "/vehicle-identification",
            ICON_SIDEBAR: "/images/_SVGs/orcamento_icon.svg",
            ICON_DASHBOARD: "/images/_SVGs/chassis.svg",
        },
        MAINTENANCE_REPAIR_QUOTATION: {
            ID: 2,
            ROUTE: "/budget",
            ICON_SIDEBAR: "/images/_SVGs/sidebar/estimar-reparacao.svg",
            ICON_DASHBOARD: "/images/_SVGs/dashboard/estimar_operacao.svg",
        },
        TECHNICAL_INFORMATION: {
            ID: 4,
            ROUTE: "/tech-info",
            ICON_SIDEBAR: "/images/_SVGs/sidebar/informacao_tecnica_menu.svg",
            ICON_DASHBOARD: "/images/_SVGs/dashboard/informacao_tecnica.svg",
        },
        PARTS_INFORMATION: {
            ID: 5,
        },
        ACTIVE_RECEPTION: {
            ID: 6,
            ROUTE: "/active-reception",
            ICON_SIDEBAR: "/images/_SVGs/sidebar/recepcao_ativa_menu.svg",
            ICON_DASHBOARD: "/images/_SVGs/dashboard/check_in_viatura.svg",
        },
        WEBSHOP: {
            ID: 7,
            ICON_SIDEBAR: "/images/_SVGs/sidebar/webshop_menu.svg",
            ICON_DASHBOARD: "/images/_SVGs/dashboard/encomendar_pecas.svg",
        },
        ENVIRONMENTAL_MANAGEMENT: {
            ID: 8,
            ROUTE: "/environmental",
            ICON_SIDEBAR: "/images/_SVGs/sidebar/gestaoambiental_menu.svg",
            ICON_DASHBOARD: "/images/_SVGs/gerir-residuos.svg",
        },
        BACKOFFICE: {
            ID: 9,
        },
        SUPPLIER_MANAGEMENT: {
            ID: 10,
        },
        CATALOGS: {
            ID: 11,
        },
        PLANNING: {
            ID: 15,
            ROUTE: "/planning",
            ICON_SIDEBAR: "/images/_SVGs/sidebar/agendamento_menu.svg",
            ICON_DASHBOARD: "/images/_SVGs/dashboard/planear_servico.svg",
        },
        MY_GARAGE: {
            ID: 16,
            ROUTE: "/mygarage",
            ICON_SIDEBAR: "/images/_SVGs/sidebar/mygarage_menu.svg",
            ICON_DASHBOARD: "/images/_SVGs/dashboard/analisar_negocio.svg",
            ACTIVE: false,
        },
        MARKETING: {
            ID: 17,
            ROUTE: "/marketing",
            ICON_SIDEBAR: "/images/_SVGs/sidebar/marketing_menu.svg",
            ICON_DASHBOARD: "/images/_SVGs/fidelizar-clientes.svg",
        },
        ERP: {
            ID: 18,
            ICON_SIDEBAR: "/images/_SVGs/sidebar/erp.svg",
            ICON_DASHBOARD: "/images/_SVGs/dashboard/programa_faturacao.svg",
        },
        CHAT: {
            ID: 19,
        },
        DATAREPAIR: {
            ID: 20,
            ICON_SIDEBAR: "/images/_SVGs/sidebar/datarepair.svg",
            ICON_DASHBOARD: "/images/_SVGs/dashboard/datarepair.svg",
        },
        DSB: {
            ID: 21,
            ICON_SIDEBAR: "/images/_SVGs/sidebar/dsb-pequeno-menu-lateral.svg",
            ICON_DASHBOARD: "/images/_SVGs/dashboard/digital_service_book.svg",
        },
        PROMO_ENGINE: {
            ID: 22,
            ROUTE: "/promo-engine",
            ICON_SIDEBAR: "/images/_SVGs/marketing.svg",
            ICON_DASHBOARD: "/images/_SVGs/dashboard/marketing_dash.svg",
        },
        AUTOCOM: {
            ID: 23,
            ICON_SIDEBAR: "/images/_SVGs/sidebar/autocom.svg",
            ICON_DASHBOARD: "/images/_SVGs/dashboard/autocom.svg",
        },
        REQUEST_MANAGER: {
            ID: 24,
            ROUTE: "/request-manager",
            ICON_SIDEBAR: "/images/_SVGs/sidebar/webshop_menu.svg",
            ICON_DASHBOARD: "/images/_SVGs/dashboard/encomendar_pecas.svg",
        },
    },
    BUSINESS_CONDITION: {
        LIGEIROS: 1,
        PESADOS: 2,
        LIGEIROS_PESADOS: 3,
        IAM: 4,
        INFO_ADICIONAL_FLUIDOS: 5,
        TRUNCATE_REFERENCE: 6,
        WASTE_PARTS: 7,
        ORDER_PARTS: 8,
        DRIVE_RIGHT_DATA: 9,
        RETURN_PARTS_NO_MATCH_SM: 10,
        WITH_ERP: 11,
        HIDE_ARTICLES_STOCK_ZERO: 12,
        IAM_WITHOUT_SM: 15,
    },
    DATASOURCE: {
        PT: "1",
        FR: "2",
        ES: "3",
        IT: "4",
    },
    ENTITY_STATUS: {
        ACTIVE: 1,
        ARCHIVED: 2,
        INACTIVE: 3,
    },
    ERROR_CODES: {
        NO_CONTENT: 204,
        BAD_REQUEST: 400,
        CONFLICT: 409,
        TOO_MANY_REQUESTS: 429,
    },
    TRUNCATED_TEXT: "******",
    ATTRIB_ID: {
        PLATE_NBR: 2,
        PLATE_DATE: 3,
        NBR_RECORDS: 4,
        MAKE: 5,
        MODEL: 7,
        VERSION: 11,
        MARK_FROM: 12,
        MARK_TO: 13,
        BUILD_YEAR: 14,
        COLOR: 15,
        VIN: 17,
        GROSS_WEIGHT: 18,
        CATEGORY: 19,
        VEH_TYPE: 20,
        BODY: 21,
        HOMOLOG_EU: 22,
        HOMOLOG_PT: 23,
        CUBIC_CAP: 24,
        POWER_KW: 25,
        POWER_CV: 26,
        FUEL_TYPE: 27,
        NBR_SEATS: 28,
        CO2: 29,
        REGIST_DATE: 30,
        OWNER_TYPE: 31,
        IDENT_OWNER_TYPE: 32,
        ZIP_CODE_4: 33,
        ZIP_CODE_3: 34,
        CITY: 35,
        NBR_DOORS: 36,
        BODY_GROUP: 37,
        GEARBOX: 39,
        ENGINE_CODE: 41,
        KURB_WEIGHT: 42,
        TIRE_FRONT: 43,
        TIRE_REAR: 44,
        VAR_EU: 45,
        VER_EU: 46,
        VEHICLE_ID: 49,
        STATUS_PARC: 50,
        IS_IMPORTED: 51,
        DRIVE: 53,
        LENGTH: 54,
        WIDTH: 55,
        HEIGHT: 56,
        NBR_CYLINDERS: 73,
        NBR_VALVES_PER_CYL: 74,
        PREVIOUS_PLATE_NBR: 75,
        PREVIOUS_PLATE_DATE: 76,
        WHEELBASE: 77,
        VEHICLE_PHOTO: 78,
        SEGMEMT_TIPS: 79,
        ELECTRIFICATION_TYPE: 80,
        AUTONOMY_WLTP: 81,
        PREVIOUS_PLATE_NBR_COUNTRY: 82,
        NBR_VEHICLES: 83,
        IS_TRUCK: 86,
    },
    QUOTATION_TYPE: {
        MAINTENANCE_OVERHAUL: 1,
        REPAIR: 2,
        PLANNING_OPERATIONS_TYPE: 3,
        TYRES: 4,
        SIMPLE_REVISION: 5,
    },
    REQUEST: {
        STATUS: {
            NO_STATUS: 0,
            SENT: 1,
            PENDING: 2,
            ONGOING: 3,
            RESOLVED: 4,
            CLOSED: 5,
            ORDER_PENDING: 6,
            ORDERED: 7,
        },
        TYPE: {
            PRICE: 1,
            ORDER: 2,
        },
    },
    DSB_CODES: {
        ERROR: 1,
        SYNCED: 2,
        SUBMITTED: 3,
        DONE: 4,
    },
};
